import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { articles } from '@/mocks/articleData';

export default function Articles() {
  return (
    <>
      <Navbar />
      <main>
        <div className="pt-16 md:pt-18 bg-background-50">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '影视资讯' },
            ]}
          />

          <section className="py-6 md:py-10">
            <div className="container-custom">
              <h1 className="font-serif text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
                影视资讯
              </h1>
              <p className="text-sm text-foreground-500 mb-8">
                最新日本影视动态、影评推荐、行业资讯
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {articles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.id}`}
                    className="group bg-white rounded-xl overflow-hidden hover:bg-background-50 transition-all duration-300"
                  >
                    <div className="aspect-video overflow-hidden">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                        title={`${article.title} - 日本在线观看 影视资讯`}
                      />
                    </div>
                    <div className="p-4 md:p-5">
                      <div className="flex items-center gap-2 mb-3">
                        <span className="text-xs px-2 py-0.5 bg-primary-100 text-primary-700 rounded-md">
                          {article.categoryName}
                        </span>
                        <span className="text-xs text-foreground-400">{article.publishDate}</span>
                      </div>
                      <h2 className="font-serif font-semibold text-foreground-900 text-base md:text-lg mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                        {article.title}
                      </h2>
                      <p className="text-sm text-foreground-500 line-clamp-2 mb-3">
                        {article.excerpt}
                      </p>
                      <div className="flex items-center justify-between text-xs text-foreground-400">
                        <span>{article.author}</span>
                        <span className="flex items-center gap-1">
                          <i className="ri-eye-line"></i>
                          {article.readCount.toLocaleString()} 阅读
                        </span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}